import { useEffect } from "react";
import { toast } from "react-toastify";

// Shows an error as a popup (the app's toast, top right) instead of red text inside the page, so the layout does not move.
// The same message is shown once at a time. Use it for the result of an action (follow, save, load more); keep a message
// under a form field for a value that has to be fixed, and keep the retry panel for a page that could not load at all.
export function showError(message) {
  if (message) toast.error(String(message), { toastId: String(message) });
}

// Shows `message` as a popup whenever it changes to something non-empty.
export function useErrorToast(message) {
  useEffect(() => { if (message) showError(message); }, [message]);
}
